import React from 'react';

import { connect } from 'react-redux';

import { selectors } from 'wanderu-ducks-browser-meta';

import AcountLinks from '../AccountMenu/AccountLinks/AccountLinks';

function AcountLinksContainer(props) {
    return (
        <AcountLinks {...props} />
    );
}

function mapStateToProps(appState) {
    return {
        capabilities: selectors.selectFeatureCapabilities(appState),
    };
}

export {
    AcountLinksContainer,
    mapStateToProps,
};
export default connect(mapStateToProps)(AcountLinksContainer);
